import request from "@/utils/request";

// 列表
export function getList(data) {
  return request({
    url: "/api/science/get",
    method: "post",
    data,
  });
}
// 详情
export function getDeatil(params) {
  return request({
    url: "/api/science/detail",
    method: "get",
    params,
  });
}